(function(){'use strict';
 
  function getDiscountPct(li){
    var cur=li.querySelector('.price__current');
    var was=li.querySelector('.price__was')||li.querySelector('s');
    if(!cur||!was)return 0;
    var c=parseFloat(cur.textContent.replace(/[^0-9.]/g,''))||0;
    var w=parseFloat(was.textContent.replace(/[^0-9.]/g,''))||0;
    if(!w||w<=c)return 0;
    return(w-c)/w*100;
  }
 
  function sortByDiscount(){
    var grid=document.querySelector('.main-products-grid__results .grid');
    if(!grid)return;
    var items=Array.from(grid.querySelectorAll(':scope>li.js-pagination-result'));
    items.sort(function(a,b){return getDiscountPct(b)-getDiscountPct(a);});
    var frag=document.createDocumentFragment();
    items.forEach(function(i){frag.appendChild(i);});
    grid.appendChild(frag);
  }
 
  function isDiscountActive(){
    return window.location.search.indexOf('discount-desc')!==-1;
  }
 
  // ── desktop sort dropdown ─────────────────────────────────────────────
  function injectDesktop(){
    var cs=document.querySelector('custom-select#products-sort-by');
    if(!cs)return false;
    var lb=cs.querySelector('.custom-select__listbox');
    var btnSpan=cs.querySelector('.custom-select__btn .text-start');
    if(!lb||!btnSpan)return false;
    if(lb.querySelector('[data-value="discount-desc"]'))return true;
 
    var li=document.createElement('li');
    li.className='custom-select__option flex items-center';
    li.setAttribute('role','option');
    li.setAttribute('data-value','discount-desc');
    li.innerHTML='<span class="pointer-events-none">Highest Discount</span>';
    lb.appendChild(li);
 
    if(isDiscountActive()){
      lb.querySelectorAll('[aria-selected]').forEach(function(el){el.removeAttribute('aria-selected');});
      li.setAttribute('aria-selected','true');
      btnSpan.textContent='Highest Discount';
    }
 
    li.addEventListener('click',function(e){
      e.stopPropagation();
      lb.querySelectorAll('[aria-selected]').forEach(function(el){el.removeAttribute('aria-selected');});
      li.setAttribute('aria-selected','true');
      btnSpan.textContent='Highest Discount';
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by','discount-desc');
      window.history.replaceState({},'',url.toString());
      var btn=cs.querySelector('.custom-select__btn');
      if(btn&&btn.getAttribute('aria-expanded')==='true')btn.click();
      sortByDiscount();
    });
    return true;
  }
 
  // ── mobile sort drawer ────────────────────────────────────────────────
  function injectMobile(){
    var ul=document.querySelector('#filter-sort .filter__content ul');
    if(!ul)return false;
    if(ul.querySelector('[data-disc-sort]'))return true;
 
    var li=document.createElement('li');
    li.setAttribute('data-disc-sort','1');
    var isActive=isDiscountActive();
    li.innerHTML='<input type="radio" id="filter-sort-disc" name="sort_by" value="discount-desc" class="checkbox"'+
      (isActive?' checked':'')+
      '><label for="filter-sort-disc" class="flex items-start w-full m-0"><span class="flex-auto">Highest Discount</span></label>';
    ul.appendChild(li);
 
    li.querySelector('input').addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by','discount-desc');
      window.history.replaceState({},'',url.toString());
      setTimeout(function(){
        var closeBtn=document.querySelector('.js-close-drawer-mob')||document.querySelector('.js-close-drawer');
        if(closeBtn)closeBtn.click();
        sortByDiscount();
      },50);
    });
    return true;
  }
 
  // ── polling: retry until custom-select is ready (fixes slow CDN / international users) ──
  var dDone=false,mDone=false,tries=0;
  function tryInit(){
    if(!dDone)dDone=injectDesktop();
    if(!mDone)mDone=injectMobile();
    if((!dDone||!mDone)&&tries++<25)setTimeout(tryInit,200);
  }
 
  function start(){
    tryInit();
    if(isDiscountActive())setTimeout(sortByDiscount,400);
  }
 
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start);
  }else{
    start();
  }
 
  // Re-sort after AJAX filter updates
  document.addEventListener('facet-filters:updated',function(){
    if(isDiscountActive())setTimeout(sortByDiscount,300);
  });
 
})();
 